module.exports = __webpack_public_path__ + "media/byebye.038bfa57.mp4";